<p-dialog visible="true" [maximizable]="false" [modal]="true" appendTo="body" [closable]="false"
    [style]="{ 'min-width': '275px' }">
    <p-header> {{ config.header }} </p-header>
    <form [formGroup]="companyFormGroup">
        <fieldset>
            <p-dropdown [autoDisplayFirst]="false" appendTo="body" [options]="companies" [filter]="true"
                formControlName="company" [required]="true"></p-dropdown>
        </fieldset>
    </form>
    <ng-template #footer >
        <button pButton label="Cancel" icon="pi pi-times" (click)="onCancel()"
            class="p-button-text p-button-danger"></button>
        <button pButton label="Save" icon="pi pi-check" (click)="onSave(this.companyFormGroup.value)"
            class="p-button-text p-button-success" [disabled]="this.companyFormGroup.invalid"></button>
    </ng-template>
</p-dialog>
